import formatText from './format-text'

export default function setDescription(description) {
    return formatText(description)
}
